import { render, staticRenderFns } from "./ReceivedPaymentSummaryCard.vue?vue&type=template&id=707f99f1&scoped=true&lang=pug&"
import script from "./ReceivedPaymentSummaryCard.vue?vue&type=script&lang=js&"
export * from "./ReceivedPaymentSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707f99f1",
  null
  
)

export default component.exports